import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const el = document.getElementById('hero-cta');
      if (!el) return;
      setVisible(el.getBoundingClientRect().bottom < 0);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, []);
  return <AnimatePresence data-id="element-33" data-mp="2avb971xpodur">
      {visible && <motion.div initial={{
      y: '100%',
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: '100%',
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 bg-navy-950/95 px-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] pt-3 backdrop-blur" data-id="element-34" data-mp="38ap6uupb06ci">
          <div className="mx-auto flex max-w-md justify-center" data-id="element-35" data-mp="335nexgb0qyzw">
            <a href={CHECKOUT_URL} className="animate-shake-burst flex w-full items-center justify-center gap-2 rounded-2xl bg-gold-400 px-4 py-4 font-display text-[15px] font-extrabold uppercase tracking-tight text-navy-950 shadow-[0_4px_0_0_#B9832A] focus-visible:outline focus-visible:outline-4 focus-visible:outline-accent-400 sm:text-base" data-id="element-36" data-mp="2pbcydm96eb4x">
              Get the blueprint — only $27
              <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-37" data-mp="26fd424sq6vi6" />
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}